import { Privilege } from '../models/privilege';

// permission func
const isNotSameUser: (curUserId: string, confirmUserId: string) => boolean = (curUserId, confirmedUserId) => {
  return curUserId !== confirmedUserId;
};

// privilege has the highest fineness, if any values are in array, split them into each row
const PRIVILEGE: Privilege = {
  viewApproveButton: [
    {
      resource: 'temporary_save_btn',
      role: 'normal',
      status: 'temporary_save',
    },
    {
      resource: 'temporary_save_btn',
      role: 'approval',
      status: 'temporary_save',
    },
    {
      resource: 'temporary_save_btn',
      role: 'normal',
      status: 'none',
    },
    {
      resource: 'temporary_save_btn',
      role: 'approval',
      status: 'none',
    },
    {
      resource: 'temporary_save_btn',
      role: 'normal',
      status: 'admitted',
    },
    {
      resource: 'temporary_save_btn',
      role: 'approval',
      status: 'admitted',
    },
    {
      resource: 'confirmation_request_btn',
      role: 'normal',
      status: 'temporary_save',
    },
    {
      resource: 'confirmation_request_btn',
      role: 'approval',
      status: 'temporary_save',
    },
    {
      resource: 'confirmation_request_btn',
      role: 'normal',
      status: 'new',
    },
    {
      resource: 'confirmation_request_btn',
      role: 'normal',
      status: 'none',
    },
    {
      resource: 'confirmation_request_btn',
      role: 'normal',
      status: 'admitted',
    },
    {
      resource: 'approval_request_btn',
      role: 'normal',
      status: 'wait_for_confirmed',
      isNotSameUser: isNotSameUser,
    },
    {
      resource: 'confirmation_request_btn',
      role: 'approval',
      status: 'new',
    },
    {
      resource: 'confirmation_request_btn',
      role: 'approval',
      status: 'none',
    },
    {
      resource: 'confirmation_request_btn',
      role: 'approval',
      status: 'admitted',
    },
    {
      resource: 'approval_request_btn',
      role: 'approval',
      status: 'wait_for_confirmed',
    },
    {
      resource: 'approval_btn',
      role: 'approval',
      status: 'wait_for_approval',
    },
    {
      resource: 'confirmation_cancel_btn',
      role: 'normal',
      status: 'wait_for_confirmed',
      isNotSameUser: isNotSameUser,
    },
    {
      resource: 'confirmation_cancel_btn',
      role: 'approval',
      status: 'wait_for_confirmed',
    },
    {
      resource: 'turn_back_btn',
      role: 'approval',
      status: 'wait_for_approval',
    },
  ],
  editFormFields: [
    {
      role: 'normal',
      status: 'new',
    },
    {
      role: 'normal',
      status: 'none',
    },
    {
      role: 'normal',
      status: 'admitted',
    },
    {
      role: 'normal',
      status: 'temporary_save',
    },
    {
      role: 'approval',
      status: 'new',
    },
    {
      role: 'approval',
      status: 'none',
    },
    {
      role: 'approval',
      status: 'admitted',
    },
    {
      role: 'approval',
      status: 'temporary_save',
    },
  ],
};

export { PRIVILEGE };
